import { createIcon } from '../createIcon';

export const NotStartedIconConfig = {
  name: 'NotStartedIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M512.096,-0.032 C794.336,-0.032 1024.032,229.728 1024.032,511.968 C1024.032,794.336 794.336,1023.968 512.096,1023.968 C229.664,1023.968 0.032,794.336 0.032,511.968 C0.032,229.728 229.664,-0.032 512.096,-0.032 Z M512.096,127.904 C300.32,127.904 128.096,300.192 128.096,511.904 C128.096,723.808 300.32,895.904 512.096,895.904 C723.808,895.904 896.096,723.744 896.096,511.904 C896.032,300.192 723.808,127.904 512.096,127.904 Z M264,432 C308.18278,432 344,467.81722 344,512 C344,556.18278 308.18278,592 264,592 C219.81722,592 184,556.18278 184,512 C184,467.81722 219.81722,432 264,432 Z M513,432 C557.18278,432 593,467.81722 593,512 C593,556.18278 557.18278,592 513,592 C468.81722,592 433,556.18278 433,512 C433,467.81722 468.81722,432 513,432 Z M761,432 C805.18278,432 841,467.81722 841,512 C841,556.18278 805.18278,592 761,592 C716.81722,592 681,556.18278 681,512 C681,467.81722 716.81722,432 761,432 Z',
  yOffset: 0,
  xOffset: 0,
};

export const NotStartedIcon = createIcon(NotStartedIconConfig);

export default NotStartedIcon;